import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Typography } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import { StyledCard, TableWrapper, StyledTable, EmptyStateText } from './Styles';
import { addCommasInPrices } from './constants';
import { ItemSalesSectionProps } from './types';
import { ITEM_TABLE_COLUMNS, EMPTY_STATE_MESSAGES } from './constants';

const { Title } = Typography;

const ItemSalesSection: React.FC<ItemSalesSectionProps> = ({ reportData }) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  if (!reportData?.itemSales?.items || reportData.itemSales.items.length === 0) {
    return (
      <ThemeProvider theme={theme}>
        <StyledCard title={<Title level={4} style={{ margin: 0 }}>Item Sales</Title>}>
          <EmptyStateText>{EMPTY_STATE_MESSAGES.ITEM_SALES}</EmptyStateText>
        </StyledCard>
      </ThemeProvider>
    );
  }

  const items = reportData.itemSales.items.map((item: any) => ({
    ...item,
    revenue: `$${addCommasInPrices(item.revenue || 0)}`,
    averagePrice: `$${addCommasInPrices(item.averagePrice || 0)}`,
  }));

  return (
    <ThemeProvider theme={theme}>
      <StyledCard title={<Title level={4} style={{ margin: 0 }}>Item Sales</Title>}>
        <TableWrapper>
          <StyledTable
            columns={ITEM_TABLE_COLUMNS}
            dataSource={items}
            rowKey={(record, index) => `item-${index}`}
            pagination={false}
            size="middle"
          />
        </TableWrapper>
      </StyledCard>
    </ThemeProvider>
  );
};

export default ItemSalesSection;
